/*=========================================================================================
  File Name: module-usertax.js
  Description: UserTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-company-state';
import mutations from './module-company-mutations';
import actions from './module-company-actions';
import getters from './module-company-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
